"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _ArrowDropDown = _interopRequireDefault(require("@material-ui/icons/ArrowDropDown"));

var _mobxReact = require("mobx-react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Menu = _interopRequireDefault(require("./Menu"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex'
    },
    buttonRoot: {
      '&:hover': {
        backgroundColor: (0, _styles.alpha)(theme.palette.primary.contrastText, theme.palette.action.hoverOpacity),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }
  };
});

function DropDownMenu(_ref) {
  var menuTitle = _ref.menuTitle,
      session = _ref.session,
      menuItems = _ref.menuItems;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var anchorEl = (0, _react.useRef)(null);
  var classes = useStyles();

  function handleToggle() {
    setOpen(!open);
  }

  function handleMenuItemClick(_event, callback) {
    callback(session);
    handleClose();
  }

  function handleClose() {
    setOpen(false);
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    ref: anchorEl,
    onClick: handleToggle,
    color: "inherit",
    "data-testid": "dropDownMenuButton",
    classes: {
      root: classes.buttonRoot
    }
  }, menuTitle, /*#__PURE__*/_react.default.createElement(_ArrowDropDown.default, null)), /*#__PURE__*/_react.default.createElement(_Menu.default, {
    anchorEl: anchorEl.current,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    onMenuItemClick: handleMenuItemClick,
    open: open,
    onClose: handleClose,
    menuItems: menuItems
  }));
}

DropDownMenu.propTypes = {
  menuTitle: _propTypes.default.string.isRequired,
  menuItems: _mobxReact.PropTypes.arrayOrObservableArray.isRequired,
  session: _mobxReact.PropTypes.objectOrObservableObject.isRequired
};

var _default = (0, _mobxReact.observer)(DropDownMenu);

exports.default = _default;